import React from 'react';

// Small hand-drawn icons shared between the header's dropdown menus and the
// LandingSidebar on each topic's landing page, so the same framework gets
// the same icon in both places. Same minimal stroke style throughout.
const iconProps = {
    width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none",
    xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true",
    stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round"
};

const iconClass = "mr-2 flex-none text-gray-400";

export const OverviewIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <circle cx="12" cy="12" r="8"/>
        <path d="M14.8 9.2l-1.8 4.4-4.4 1.8 1.8-4.4z"/>
    </svg>
);

export const MlNetIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <rect x="8" y="8" width="8" height="8" rx="1"/>
        <path d="M12 3v4M12 17v4M3 12h4M17 12h4"/>
    </svg>
);

export const SciPyIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <path d="M10 3v6.5L5.5 18a1.8 1.8 0 0 0 1.6 2.6h9.8a1.8 1.8 0 0 0 1.6-2.6L14 9.5V3"/>
        <path d="M9 3h6"/>
        <path d="M7.5 15h9"/>
    </svg>
);

export const ScikitLearnIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <circle cx="6" cy="7" r="1.4"/>
        <circle cx="18" cy="7" r="1.4"/>
        <circle cx="12" cy="12" r="1.4"/>
        <circle cx="6" cy="17" r="1.4"/>
        <circle cx="18" cy="17" r="1.4"/>
        <path d="M7.3 8.1L10.7 11M16.7 8.1L13.3 11M7.3 15.9L10.7 13M16.7 15.9L13.3 13"/>
    </svg>
);

export const TensorFlowIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <rect x="4" y="4.5" width="16" height="4" rx="1"/>
        <rect x="4" y="10" width="16" height="4" rx="1"/>
        <rect x="4" y="15.5" width="16" height="4" rx="1"/>
    </svg>
);

export const PyTorchIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <path d="M12 3c-2.5 3-5.5 5.5-5.5 9.5a5.5 5.5 0 0 0 11 0c0-2-1-3.3-2.2-4.5.3 2-1 3-1.3 3-.3-2.2-2-3.5-2-5s.6-2 0-3z"/>
    </svg>
);

// Silo, matching Orleans' own "Silos" and "Grains" terminology.
export const OrleansIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <ellipse cx="12" cy="6" rx="6" ry="2.5"/>
        <path d="M6 6v12c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5V6"/>
        <path d="M6 12c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5"/>
    </svg>
);

// Parallel flowing arrows, for a unified batch/streaming data pipeline.
export const BeamIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <path d="M3 8h13M12 4l4 4-4 4"/>
        <path d="M3 16h9M8 12l4 4-4 4"/>
    </svg>
);

export const SparkIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z"/>
    </svg>
);

// Message bubble, for Akka's actor message-passing model.
export const AkkaIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <path d="M4 5h16v11H9l-4 4v-4H4z"/>
        <path d="M8 9h8M8 12h5"/>
    </svg>
);

// Storm cloud.
export const StormIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <path d="M7 16a4 4 0 0 1 .3-8 5 5 0 0 1 9.6 1.8A3.3 3.3 0 0 1 17 16H7z"/>
    </svg>
);

// A pair of simple flying-bird doodles, for Heron.
export const HeronIcon = () => (
    <svg className={iconClass} {...iconProps}>
        <path d="M3 12c3-3 6-3 9 0 3-3 6-3 9 0"/>
        <path d="M3 16c3-3 6-3 9 0 3-3 6-3 9 0"/>
    </svg>
);
